// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Yhnq","badges":"styles_badges__bGjR3"};